// Καρτέλα εναλλαγής προβολής: «Ενεργές / Αρχειοθετημένες / Δημόσιες» στον κατάλογο
// συλλογών, «Ο πόρος / Κρίσεις» στο παράθυρο του πόρου σε στενή οθόνη.
//
// Ζούσε τοπικά μέσα στον κατάλογο συλλογών. Μετακόμισε στα κοινά όταν χρειάστηκε
// **δεύτερος** καταναλωτής: αντιγραφή δεκαπέντε γραμμών θα ήταν η κατηγορία ΣΤ σε
// μικρογραφία — δύο αντίγραφα του ίδιου στοιχείου που αποκλίνουν σιωπηλά, με το ένα
// να χάνει το `aria-pressed` ή τον δακτύλιο εστίασης χωρίς να το προσέξει κανείς.
//
// Το `aria-pressed` δεν είναι διακοσμητικό: χωρίς αυτό ο αναγνώστης οθόνης ακούει
// τρία κουμπιά και καμία ένδειξη ποιο είναι ενεργό — η πληροφορία θα υπήρχε **μόνο**
// στο χρώμα (ΜΛΑ-11).

export default function ViewTab({ icon, isActive, onPress, children }) {
    return (
        <button
            type="button"
            aria-pressed={isActive}
            onClick={onPress}
            className={[
                'inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium',
                'transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus',
                isActive
                    ? 'bg-accent text-accent-foreground'
                    : 'text-muted hover:bg-accent-soft hover:text-accent-soft-foreground'
            ].join(' ')}
        >
            <i className={icon} aria-hidden="true" />
            {children}
        </button>
    );
}
